//Constants
import * as ACTIONS from './actionTypes';

//Types
import { UIListingLocation } from './types';
import { ActionGetDealerEnginePreviewSuccess } from 'features/Dealers/Listings/GMBPreview/state/actions';

export interface DealerEnginePreviewState {
    gmbPreview?: UIListingLocation
}

const defaultState: DealerEnginePreviewState = {
};

type GMBPreviewAction = ActionGetDealerEnginePreviewSuccess

function dealerEnginePreviewReducer(state: DealerEnginePreviewState = defaultState, action: GMBPreviewAction): DealerEnginePreviewState {
    switch (action.type) {
        case ACTIONS.GET_DEALER_ENGINE_PREVIEW_API_SUCCESS:
            {
                const preview = (action as GMBPreviewAction).enginePreview
                return {
                    ...state,
                    gmbPreview: preview,
                }
            }
    }
    return {
        ...state
    }
}



export default dealerEnginePreviewReducer;